import type { Row } from '@vincjo/datatables/remote';

export interface BaseListResponse {
  total: number;
  data: Row[];
}

export enum SortBy {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

// Error response interface compatible with both Problem Details and legacy formats
export interface ErrorResponse {
  message?: string; // Legacy format
  detail?: string; // Problem Details format
  type?: string; // Available in both formats
  title?: string; // Problem Details format
  status?: number; // Problem Details format
  traceId?: string; // Available in both formats
  timestamp?: string; // Problem Details format
  instance?: string; // Problem Details format
}

export interface IdName {
  id: number | undefined;
  name: string;
}

export interface NameEnabled {
  name: string;
  enabled: boolean;
}

export enum MenuConfig {
  MyDashboard = 'My Dashboard',
  MyQueue = 'My Queue',
  PurchaseOrder = 'Purchase Order',
  PurchaseOrderPipeline = 'Purchase Order Pipeline',
  CreatePO = 'Create PO',
  Invoice = 'Invoice',
  InvoicePipeline = 'Invoice Pipeline',
  InvoiceUpload = 'Invoice Upload',
  EmailIngestion = 'Email Ingestion',
  ExpenseClaim = 'Expense Claim',
  ExpenseClaimPipeline = 'Expense Claim Pipeline',
  CreateClaim = 'Create Claim',
}

export enum DateFilters {
  Today = 'Today',
  LastSevenDays = 'LastSevenDays',
  LastFourteenDays = 'LastFourteenDays',
  LastMonth = 'LastMonth',
  LastQuarter = 'LastQuarter',
  LastTwelveMonths = 'LastTwelveMonths',
}

export enum AliiConnectionType {
  Unknown = 'Unknown',
  None = 'None',
  SQL = 'SQL',
  Synergetics = 'Synergetics',
  GreenTree = 'GreenTree',
  MYOBAdvanced = 'MYOBAdvanced',
  LoanCalculator = 'LoanCalculator',
  Reckon = 'Reckon',
  MYOBAccountRight = 'MYOBAccountRight',
  PCSchool = 'PCSchool',
  Xero = 'Xero',
  Veracross = 'Veracross',
  MYOBAccountRightV2 = 'MYOBAccountRightV2',
  PublicApi = 'PublicApi',
  TassV2 = 'TassV2',
  XeroV2 = 'XeroV2',
  MSBusinessCentral = 'MSBusinessCentral',
  AccountsIQ = 'AccountsIQ',
  WCBS = 'WCBS',
}
